import React from 'react';
import { Alert as MuiAlert } from '@itsa.io/ui';

const Alert = props => {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
};

export default Alert;
